import BVASelect from "../../../components/BVASelect/BVASelect";
import { useState } from "react";
import { connect } from "react-redux";
import BizminerRatios from "./BizminerRatios/BizminerRatios"
import VerticalIQRatios from "./VerticalIQRatios/VerticalIQRatios";
import IBISWorldRatios from "./IBISWorldRatios/IBISWorldRatios";
import FirstResearchRatios from "./FirstResearchRatios/FirstResearchRatios";
import DupontRatios from "./DupontRatios/DupontRatios";
import AltmanZScore from "./AltmanZScore/AltmanZScore";
import { ASCENDANT_ORDER, DESCENDANT_ORDER, MONTHLY, YEARLY } from "../../../config";
import { updateRatiosDateOrder, updateRatiosPeriod } from "../../../store/modules/financialRatios/actions";

const BIZMINER_RATIOS_SECTION = "BIZMINER_RATIOS_SECTION"
const VERTICAL_IQ_RATIOS_SECTION = "VERTICAL_IQ_RATIOS_SECTION"
const IBIS_WORLD_RATIOS_SECTION = "IBIS_WORLD_RATIOS_SECTION"
const FIRST_RESEARCH_RATIOS_SECTION = "FIRST_RESEARCH_RATIOS_SECTION"
const DUPONT_RATIOS_SECTION = "DUPONT_RATIOS_SECTION"
const ALTMAN_Z_SCORE_SECTION = "ALTMAN_Z_SCORE_SECTION"

const acquisitionsExpensesSections = [
  { label: "Bizminer Ratios", value: BIZMINER_RATIOS_SECTION },
  { label: "Vertical IQ Ratios", value: VERTICAL_IQ_RATIOS_SECTION },
  { label: "IBIS World Ratios", value: IBIS_WORLD_RATIOS_SECTION },
  { label: "First Research Ratios", value: FIRST_RESEARCH_RATIOS_SECTION },
  { label: "DuPont Ratios", value: DUPONT_RATIOS_SECTION },
  { label: "Altman Z Score", value: ALTMAN_Z_SCORE_SECTION },
]

const dateOrders = [
  { label: "Dates ascendant", value: ASCENDANT_ORDER },
  { label: "Dates descendant", value: DESCENDANT_ORDER },
];

const visualizationOptions = [
  { label: "Monthly", value: MONTHLY },
  { label: "Yearly", value: YEARLY }
]

function Ratios({ dispatchUpdateRatiosDateOrder, dispatchUpdateRatiosPeriod }) {

  // States
  const [selectedSection, setSelectedSection] = useState(BIZMINER_RATIOS_SECTION);
  const [selectedDateOrder, setSelectedDateOrder] = useState(DESCENDANT_ORDER);
  const [selectedVisualization, setSelectedVisualization] = useState(MONTHLY);

  // Methods
  const getSection = () => {
    switch(selectedSection) {

      case BIZMINER_RATIOS_SECTION:
        return <BizminerRatios />

      case VERTICAL_IQ_RATIOS_SECTION:
        return <VerticalIQRatios />

      case IBIS_WORLD_RATIOS_SECTION:
        return <IBISWorldRatios />

      case FIRST_RESEARCH_RATIOS_SECTION:
        return <FirstResearchRatios />

      case DUPONT_RATIOS_SECTION:
        return <DupontRatios dateOrder = {selectedDateOrder} prefix = {selectedVisualization} />
      
      case ALTMAN_Z_SCORE_SECTION:
        return <AltmanZScore dateOrder = {selectedDateOrder} prefix = {selectedVisualization} />

      default:
        break
    }
  }

  const handleDateOrderOnChange = (dateOrder) => {
    dispatchUpdateRatiosDateOrder(dateOrder);
    setSelectedDateOrder(dateOrder);
  };

  const handlePeriodOnChange = (period) => {
    dispatchUpdateRatiosPeriod(period);
    setSelectedVisualization(period);
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <BVASelect
            items={acquisitionsExpensesSections}
            value={selectedSection}
            width="24em"
            placeholder="Select a section"
            onChange={(value) => setSelectedSection(value)}
          />
          {selectedSection === DUPONT_RATIOS_SECTION || selectedSection === ALTMAN_Z_SCORE_SECTION ? (
            <div className="ml-4">
              <BVASelect
                items={visualizationOptions}
                value={selectedVisualization}
                width="10em"
                placeholder="Select a section"
                onChange={(value) => handlePeriodOnChange(value)}
              />
            </div>
          ) : (
            <div />
          )}
        </div>
        {selectedSection === DUPONT_RATIOS_SECTION || selectedSection === ALTMAN_Z_SCORE_SECTION ? (
          <BVASelect
            items={dateOrders}
            value={selectedDateOrder}
            width="10em"
            placeholder="Select an order"
            onChange={(value) => handleDateOrderOnChange(value)}
          />
        ) : (
          <div />
        )}
        
      </div>
      <div className="mt-20">
        {getSection()}
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchUpdateRatiosDateOrder(dateOrder) {
    await dispatch(updateRatiosDateOrder(dateOrder));
  },
  async dispatchUpdateRatiosPeriod(prefix) {
    await dispatch(updateRatiosPeriod(prefix));
  },
});

export default connect(null, mapDispatchToProps)(Ratios);
